import {
  Icon,
  Button,
  Tooltip,
} from 'web-components';

import {
  Flex,
  SVG,
} from 'web-styled';

import * as S from './styled';

type Props = {
  query: string;
  tooltipText?: string;
  onSearch: { (): void };
  onUpload: { (): void };
  onSetQuery: { (query: string): void };
};

const ManageVideoUpload = ({
  query,
  tooltipText,
  onSearch,
  onUpload,
  onSetQuery,
}: Props) => {
  const searchBar = (
    <S.Search
      onKeyDown={(e) => {
        if (e.key === 'Enter' && query) {
          onSearch();
        }
      }}
    >
      <S.Input
        autoFocus
        placeholder="Search for a video"
        value={query}
        onChange={(e) => onSetQuery(e.target.value || '')}
      />
      <S.SearchButton
        icon={<SVG.Search size={15} />}
        active={!!query}
        onClick={onSearch}
      />
    </S.Search>
  );

  return (
    <Flex
      column
      shrink="0"
      width="100%"
      spacing={5}
    >
      <Flex
        width="100%"
        spacing={30}
      >
        <Flex
          width="100%"
          column
          spacing={5}
          align="center"
        >
          {tooltipText ? (
            <Tooltip
              body={tooltipText}
              width="300px"
            >
              {searchBar}
            </Tooltip>
          ) : searchBar}
        </Flex>
        <Button
          icon={<SVG.CloudUpload />}
          appearance="success"
          onClick={onUpload}
        >
          Upload Video
        </Button>
      </Flex>
    </Flex>
  );
};

export default ManageVideoUpload;
